import PropTypes from 'prop-types'
import React, { useState } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Comment from '../Comment/index'
import CommentThreadActions from '../CommentThreadActions/index'

const DEFAULT_CHILDREN_LIMIT = 2

function getChildrenLimit (comment) {
  const count = (comment.commentsChildren || []).length
  return count > DEFAULT_CHILDREN_LIMIT ? DEFAULT_CHILDREN_LIMIT : -1
}

function CommentThread (props) {
  const {
    comment,
    loading,
    auth,
    createComment,
    updateComment,
    reportComment,
  } = props
  const [childrenLimit, setChildrenLimit] = useState(getChildrenLimit(comment))
  const [editCommentId, setEditCommentId] = useState(null)

  const commentChildren = comment.commentsChildren || []
  const children = childrenLimit === -1
    ? commentChildren
    : commentChildren.slice(-childrenLimit)

  return (
    <div className={`comment-thread${loading ? ' comment-thread--placeholders' : ''}`}>
      <Comment
        auth={auth}
        comment={comment}
        loading={loading}
        editMode={editCommentId === comment.id}
        createComment={createComment}
        updateComment={updateComment}
        onSubmitComplete={() => setEditCommentId(null)}
      />
      <CommentThreadActions
        auth={auth}
        comment={comment}
        createComment={createComment}
        updateComment={updateComment}
        reportComment={reportComment}
        onEditClick={(cid) => setEditCommentId(cid)}
        editMode={editCommentId === comment.id}
        showLimitButton={childrenLimit !== -1}
        onClickChildrenLimit={() => setChildrenLimit(-1)}
      />
      <div className="comment-thread__replies">
        {children.map((child, index) => (
          <div key={`comment-thread-${child.id}-${index}`}>
            <Comment
              auth={auth}
              comment={child}
              editMode={editCommentId === child.id}
              createComment={createComment}
              updateComment={updateComment}
              onSubmitComplete={() => setEditCommentId(null)}
            />
            <CommentThreadActions
              auth={auth}
              comment={child}
              reportComment={reportComment}
              editMode={editCommentId === child.id}
              onEditClick={(cid) => setEditCommentId(cid)}
              showLimitButton={false}
              showReplyButton={false}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

CommentThread.propTypes = {
  comment: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  loading: PropTypes.bool,
  createComment: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
  reportComment: PropTypes.func.isRequired,
}

export default CommentThread
